<template>
  <div class="longTermStorageWarehouse">
    <!-- 长存仓库 -->
    <baseBreadcrumb :page="$t('message.longTermStorageWarehouse')" :menu="$t('message.warehouse')"></baseBreadcrumb>
    <div class="body">
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 客户ID/客户名称 -->
          <div class="item">
            <el-input :placeholder="$t('message.customerID_CustomerName')" v-model="datas.user_id_or_name"></el-input>
          </div>
          <!-- 订单号 -->
          <div class="item">
            <el-input :placeholder="$t('message.orderNumber')" v-model="datas.order_sn"></el-input>
          </div>
          <!-- 箱号 -->
          <div class="item">
            <el-input :placeholder="$t('message.boxNums')" v-model="datas.box_no"></el-input>
          </div>
          <!-- 库位 -->
          <div class="item">
            <el-input :placeholder="$t('message.location')" v-model="datas.grid_number"></el-input>
          </div>
          <!-- 入库时间-开始 -->
          <div class="item">
            <el-date-picker v-model="datas.to_charge_wms_at_start" type="date" value-format="yyyy-MM-dd"
              :placeholder="$t('message.warehouseInTimeStart')" />
          </div>
          <!-- 入库时间-结束 -->
          <div class="item">
            <el-date-picker v-model="datas.to_charge_wms_at_end" type="date" value-format="yyyy-MM-dd"
              :placeholder="$t('message.warehouseInTimeEnd')" />
          </div>
          <!-- 保管天数 -->
          <div class="item">

            <el-select v-model="datas.keep_days" clearable filterable :placeholder="$t('message.warehouseStorageDays')">
              <el-option v-for="item in keepDays" :key="item.val" :label="item.label" :value="item.val">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row" style="margin:20px 0px;">
          <!-- 业务员 -->
          <div class="item">
            <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 装箱操作人 -->
          <div class="item">
            <el-select v-model="datas.pack_by" clearable filterable :placeholder="$t('message.packBy')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 搜索按钮 -->
          <div class="item">
            <el-button type="primary" @click="search">
              {{ $t('message.search') }}
            </el-button>
            <!-- 重置按钮 -->
            <el-button @click="reset">
              {{ $t('message.reset') }}
            </el-button>
          </div>
          <!--  操作-->
          <div class="btn">
            <!-- 库存导出 -->
            <el-button type="primary" class="primary">
              {{ $t('message.exportInventory') }}
            </el-button>
            <!-- 退回常规仓库 -->
            <el-button type="danger" @click="transferToRegularWarehouse">
              {{ $t('message.returnToRegularWarehouse') }}
            </el-button>
            <!--提出配送单  -->
            <el-button type="primary" @click="putForwardDeliveryOrder" v-if="isAuth(456)">
              {{ $t('message.putForwardDeliveryOrder') }}
            </el-button>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <div class="tableHeader">
          <div class="item flex05">
            <el-checkbox v-model="checked" @change="handleCheckAllChange"></el-checkbox>
          </div>
          <!--No-->
          <div class="item flex05">No</div>
          <!--客户信息 -->
          <div class="item">{{ $t('message.userInfo') }}</div>
          <!-- 箱号 -->
          <div class="item">{{ $t('message.boxNums') }}</div>
          <!-- 库位 -->
          <div class="item">{{ $t('message.location') }}</div>
          <!-- 箱内SKU数 -->
          <div class="item">{{ $t('message.boxInnerSKUNum') }}</div>
          <!-- 箱内商品数 -->
          <div class="item">{{ $t('message.boxInnerGoodsNum') }}</div>
          <!-- 实际重量 -->
          <div class="item">{{ $t('message.actualWeight') }}</div>
          <!-- 箱子尺寸 -->
          <div class="item">{{ $t('message.boxSize') }}</div>
          <!-- 入库时间(上架) -->
          <div class="item">{{ $t('message.warehouseInTimeStart') }}</div>
          <!-- 库龄（已保管天数） -->
          <div class="item">{{ $t('message.warehouseStorageDays') }}</div>
          <!-- 箱内商品价值.元 -->
          <div class="item">{{ $t('message.boxInnerGoodsValue') }}</div>
          <!-- 已产生仓储费.元 -->
          <div class="item">{{ $t('message.warehouseFeePaid') }}</div>
          <!-- 待支付仓储费.元 -->
          <div class="item">{{ $t('message.pendingPaymentWarehouseFee') }}</div>
          <!-- 装箱操作人 -->
          <div class="item">{{ $t('message.packBy') }}</div>
          <!-- 客户对应人 -->
          <div class="item">{{ $t('message.customerCorrespondingPerson') }}</div>
        </div>
        <div class="tableBody" v-for="(item, index) in tableData" :key="index">
          <div class="tableRow">
            <div class="item flex05">
              <el-checkbox v-model="item.checked" @change="handleCheckChange"></el-checkbox>
            </div>
            <div class="item flex05">{{ item.rowNumber }}</div>
            <!--客户信息 -->
            <div class="item">
              <div class="template">
                <p>
                  ID：{{ getUserId(item) }}
                </p>
                {{ getRealname(item.user) }}
              </div>
            </div>
            <!-- 箱号 -->
            <div class="item">
              <p> BOX-{{ item.source_sn }}-{{ item.box_no }}</p>
              <p style="margin-top: 10px;" class="isShow">
                <!-- 展开收起 -->
                <el-button type="info" @click="item.show = !item.show" size="mini">{{ item.show ?
                  $t('message.collapse') :
                  $t('message.expandCollapse') }}
                  <i v-if="!item.show" class="el-icon-arrow-down"></i>
                  <i v-else class="el-icon-arrow-up"></i>
                </el-button>
              </p>
            </div>
            <!-- 库位 -->
            <div class="item">
              <div class="template">
                <!-- 与常规仓库保持一致：区域用途编码和库位编码前段同色，末段使用红色。 -->
                <p>{{ item.wms_grid.wms_shelf.area_type_code}}-{{ item.grid_number.split("】-")[0] }}】-</p>
                <p style="color: #fa5058">
                  {{ item.grid_number.split("】-")[1] }}
                </p>
              </div>
            </div>
            <!-- 箱内SKU数 -->
            <div class="item">{{ item.sku_count }}</div>
            <!-- 箱内商品数 -->
            <div class="item">{{ item.total_num }}</div>
            <!-- 实际重量 -->
            <div class="item">{{ item.weight }}</div>
            <!-- 箱子尺寸 -->
            <div class="item">{{ item.attr }}</div>
            <!-- 入库时间(上架) -->
            <div class="item">{{ item.to_charge_wms_at }}</div>
            <!-- 库龄（已保管天数） -->
            <div class="item">{{ item.storage_days }}</div>
            <!-- 箱内商品价值.元 -->
            <div class="item">{{ item.goods_value }}</div>
            <!-- 已产生仓储费.元 -->
            <div class="item">{{ item.settled_storage_fee }}</div>
            <!-- 待支付仓储费.元 -->
            <div class="item">{{ item.unsettled_storage_fee }}</div>
            <!-- 装箱操作人 -->
            <div class="item">{{ getRealname(item.pack_by) }}</div>
            <!-- 客户对应人 -->
            <div class="item">
              <div class="template">
                <!--  业务 -->
                <p>
                  {{ $t('message.business') }}：{{ getUserAdminRealname(item, 'y_admin') }}
                </p>
                <!--  采购 -->
                <p>
                  {{ $t('message.purchase') }}：{{ getUserAdminRealname(item, 'g_admin') }}
                </p>
                <!--   配货 -->
                <p>
                  {{ $t('message.distribution') }}：{{ getUserAdminRealname(item, 'p_admin') }}
                </p>
              </div>
            </div>
          </div>
          <el-collapse-transition>
            <div class="commodity" v-show="item.show">
              <ol>
                <!-- 订单号 -->
                <li>{{ $t('message.orderNumber') }}</li>
                <!-- 番号 -->
                <li>{{ $t('message.mash') }}</li>
                <!-- 商品属性 -->
                <li>{{ $t('message.commodityAttribute') }}</li>
                <!-- 图片 -->
                <li>{{ $t('message.pic') }}</li>
                <!-- 数量 -->
                <li>{{ $t('message.quantity') }}</li>
              </ol>
              <ul v-for="(order, orderIndex) in item.details" :key="orderIndex">
                <!-- 订单号 -->
                <li>
                  <router-link :to="`/orderPaymentDetail?order_sn=${order.order_sn}`" target="_blank" class="a-link">
                    {{ order.order_sn }}
                  </router-link>
                </li>
                <!-- 番号 -->
                <li>{{ order.sorting }}</li>
                <!-- 商品属性 -->
                <li>
                  <div class="template">
                    <p v-for="(attr, attrIndex) in order.detail_y" :key="attrIndex">
                      {{ attr.key }}:{{ attr.value }}
                    </p>
                  </div>
                </li>
                <!-- 图片 -->
                <li>
                  <el-popover placement="right" width="300" trigger="hover">
                    <el-image :src="order.pic" style="width: 300px; height: 300px;" />
                    <a :href="getGoodsUrl(order)" target="_blank" rel="noopener" slot="reference">
                      <el-image :src="order.pic" fit="fill" style="width: 60px; height: 60px;" />
                    </a>
                  </el-popover>
                </li>
                <!-- 数量 -->
                <li>{{ order.num }}</li>
              </ul>
            </div>
          </el-collapse-transition>
        </div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[200, 300, 400]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 提出配送单弹框-->
      <el-dialog title="提出配送单" :visible.sync="dialogVisible" width="380px" center>
        <div class="content">
          <div class="toPorderList">
            <div v-html="toPorderList">
            </div>
          </div>
        </div>
        <template slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    y() {
      const group = this.$store.state.authWorkGroupAdmin || {}
      return (group.y || []).filter(Boolean);
    },
    p() {
      const group = this.$store.state.authWorkGroupAdmin || {}
      return (group.p || []).filter(Boolean);
    },
  },
  data() {
    return {
      keepDays: [
        {
          val: 30,
          label: '小于30天'
        },
        {
          val: 90,
          label: '30-90天'
        },
        {
          val: 180,
          label: '90-180天'
        },
        {
          val: 181,
          label: '180天以上'
        },

      ],
      datas: {
        user_id_or_name: '',
        order_sn: '',
        box_no: '',
        grid_number: '',
        to_charge_wms_at_start: '',
        to_charge_wms_at_end: '',
        keep_days: '',
        y_id: '',
        pack_by: '',
        page: 1,
        pageSize: 200,
      },
      tableData: [],
      total: 0,
      checked: false,
      // 配送单数据
      toPorderDatas: {
        boxes: [],
      },
      toPorderList: '',//配送单列表
      dialogVisible: false,
      // 选择中的箱子ID
      boxIds: [],

    }
  },
  created() {
    this.chargeStorageList();
  },
  methods: {
    // 兼容接口返回 null 的嵌套对象，避免表格渲染时报 realname 读取错误
    getRealname(data) {
      return data && data.realname ? data.realname : '-'
    },
    getUserId(item) {
      return item && item.user && item.user.id ? item.user.id : '-'
    },
    getUserAdminRealname(item, key) {
      return this.getRealname(item && item.user ? item.user[key] : null)
    },
    getGoodsUrl(order) {
      return order && order.link && order.link.goods_url ? order.link.goods_url : ''
    },
    // 仓储仓库箱子列表
    chargeStorageList() {
      this.checked = false;
      this.$api.warehouseApi.chargeStorageList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = false;
          item.show = false
        })
        this.tableData = res.data.data;
        this.total = res.data.total;
      })
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.chargeStorageList();
    },
    // 重置
    reset() {
      this.datas = {
        user_id_or_name: '',
        order_sn: '',
        box_no: '',
        grid_number: '',
        to_charge_wms_at_start: '',
        to_charge_wms_at_end: '',
        keep_days: '',
        y_id: '',
        pack_by: '',
        page: 1,
        pageSize: 200,
      }
      this.search();
    },
    // 分页-每页数量改变时
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.search();
    },
    // 分页-当前页改变时
    handleCurrentChange(val) {
      this.datas.page = val;
      this.chargeStorageList();
    },
    // 全选
    handleCheckAllChange() {
      this.tableData.forEach(item => {
        item.checked = this.checked;
      })
    },
    // 复选框改变时
    handleCheckChange() {
      this.checked = this.tableData.every(item => item.checked);
      this.$forceUpdate();
    },
    // 提出配送单
    putForwardDeliveryOrder() {
      this.toPorderDatas = {
        boxes: []
      }
      this.tableData.forEach(item => {
        if (item.checked) {
          this.toPorderDatas.boxes.push({
            id: item.id,
            type: item.box_type,
          });
        }
      })
      if (this.toPorderDatas.boxes == false) {
        return this.$message.error("请选择要提出配送单的箱子");
      }
      this.$api.warehouseApi.toPorder(this.toPorderDatas).then(res => {
        if (res.code == 10006) {
          this.toPorderList = res.data.replaceAll('\n', '<br/>',);
          this.dialogVisible = true;
        } else {
          this.$message.success(res.msg);
          this.search();
        }



      })
    },
    // 提交配送单
    submit() {
      this.toPorderDatas.reconfirm = 1
      this.$api.warehouseApi.toPorder(this.toPorderDatas).then(res => {
        this.$message.success("配送单提出成功");
        this.dialogVisible = false;
        this.search();
      })
    },
    // 转入常规商品仓库：和直接装箱箱子退回常规仓库一致，生成等待取出的转库单
    transferToRegularWarehouse() {
      this.boxIds = []
      this.tableData.forEach(item => {
        if (item.checked) {
          this.boxIds.push(item.id);
        }
      })
      if (this.boxIds == false) {
        return this.$message.error("请选择要转入常规商品仓库的箱子");
      }
      this.$confirm(
        '确认将选中的箱子退回常规仓库？',
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.inventoryTransferApi.returnToNormal({ boxIds: this.boxIds }).then(res => {
            this.$message.success(res.msg);
            this.chargeStorageList();
          })
        })
        .catch(() => { })
    }
  }
}
</script>
<style scoped lang="scss">
.longTermStorageWarehouse {
  padding: 20px;

  .search {
    .row {
      display: flex;

      .item {
        width: 200px;
        margin-right: 20px;

        .el-date-editor {
          width: 100%;
        }
      }

      .btn {
        margin-left: auto;
      }
    }
  }

  .table {
    .tableHeader {
      display: flex;
      line-height: 20px;
      height: 56px;
      color: #666666;
    }

    .tableBody {
      .tableRow {
        display: flex;
        background-color: #fff;
        padding: 30px 0;
        justify-content: center;
        align-items: center;
      }

    }

    .item {
      flex: 1;
      text-align: center;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    ol {
      background: #DCDFE6;
      height: 56px;
      line-height: 56px;
      color: #666666;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
    }

    .template {
      width: 100%;
      text-align: left;
    }

    .isShow {
      text-align: left;

      .el-button {
        background-color: #F6F6F6;
        border: none;
        color: #999999;
        padding: 6px 10px;

        i {
          margin-left: 10px;
        }
      }
    }
  }
}

.toPorderList {
  padding: 12px;
  background-color: #F6F6F6;
  margin-top: 12px;
  line-height: 24px;

}
</style>
